<div class="cortina" id="cortina">
  <span class="spinner hidden" id="loaderSpinner"></span>
<app-navegador></app-navegador>
<h1 class="text-center titulo">{{'actions' | translate}}</h1>
<div class="container">
  <div class="row">
    <div class="col-md-6">
      <div class="row">
        <div class="text-center">
          <p class="top-font-3 bold" >{{'total-month' | translate}}</p>
          <h1 class="top-font-1 bold">{{stats.month}} <span [ngClass]="drawStats.getClassByNumber(stats.month_percent)" class="top-font-2 color-red padding-bottom">
            <img class="img-last-month img-down" src="../assets/img/down.png" alt=""><img class="img-last-month img-up" src="../assets/img/up.png" alt=""> {{stats.month_percent}}%</span></h1>
          <div class="row">
            <div class="col-md">
              <h4 class="bold">{{'local-average' | translate}}:<span [ngClass]="drawStats.getClassByNumber(stats.average_location)" class="top-font-4 color-red">
                <img class="img-last-month img-down" src="../assets/img/down.png" alt=""><img class="img-last-month img-up" src="../assets/img/up.png" alt=""> {{stats.average_location}}%</span></h4>
            </div>
            <div class="col-md">
              <h4 class="bold">{{'compare-last-year' | translate}}:<span [ngClass]="drawStats.getClassByNumber(stats.month_year_last_percent)" class="top-font-4 color-red">
                <img class="img-last-month img-down" src="../assets/img/down.png" alt=""><img class="img-last-month img-up" src="../assets/img/up.png" alt=""> {{stats.month_year_last_percent}}%</span></h4>
            </div>
          </div>
        </div>
        <div class="row text-center">
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <p class="top-font-5"><img class="img-info" src="../assets/img/actions-web.png" alt="">{{'actions-web' | translate}}</p>
              </div>
              <div class="col-md-12">
                <h3 class="top-font-3 bold">{{stats.web}} <span [ngClass]="drawStats.getClassByNumber(stats.web_percent)" class="top-font-4 color-red padding-bottom">
                  <img class="img-last-month img-down" src="../assets/img/down.png" alt=""><img class="img-last-month img-up" src="../assets/img/up.png" alt=""> {{stats.web_percent}}%</span></h3>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <p class="top-font-5"><img class="img-info" src="../assets/img/actions-gps.png" alt="">{{'actions-indications' | translate}}</p>
              </div>
              <div class="col-md-12">
                <h3 class="top-font-3 bold">{{stats.gps}} <span [ngClass]="drawStats.getClassByNumber(stats.gps_percent)" class="top-font-4 color-red padding-bottom">
                  <img class="img-last-month img-down" src="../assets/img/down.png" alt=""><img class="img-last-month img-up" src="../assets/img/up.png" alt=""> {{stats.gps_percent}}%</span></h3>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <p class="top-font-5"><img class="img-info" src="../assets/img/actions-phone.png" alt="">{{'actions-calls' | translate}}</p>
              </div>
              <div class="col-md-12">
                <h3 class="top-font-3 bold">{{stats.calls}} <span [ngClass]="drawStats.getClassByNumber(stats.calls_percent)" class="top-font-4 color-red padding-bottom">
                  <img class="img-last-month img-down" src="../assets/img/down.png" alt=""><img class="img-last-month img-up" src="../assets/img/up.png" alt=""> {{stats.calls_percent}}%</span></h3>
              </div>
            </div>
          </div>
        </div> 
      </div>
      <div id="canvas3"><canvas class="grafic" id="myChart" width="620" height="400"></canvas></div>
    </div>
    <table class=" col-md table table-striped">
      <thead>
        <tr class="text-center">
          <th scope="col">{{'ranking' | translate}}</th>
          <th scope="col">{{'code' | translate}}</th>
          <th scope="col">{{'description' | translate}}</th>
          <th scope="col">{{'actions-total' | translate}}</th>
          <th scope="col">{{'actions-web' | translate}}</th>
          <th scope="col">{{'actions-indications' | translate}}</th>
          <th scope="col">{{'actions-calls' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr class="text-center top-font-6" *ngFor="let stat of stats.table">
          <td>{{stat.ranking}}</td>
          <td>{{stat.code}}</td>
          <td>{{stat.description}}</td>
          <td>{{stat.total}}</td>
          <td>{{stat.web}}</td>
          <td>{{stat.gps}}</td>
          <td>{{stat.call}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div>